import { GameEvent } from '../events/gameEvent';
import { EventName } from '../events/eventsName';
import { Store } from 'game/store/gameStore';
import { GameActionButton } from './GameActionButton';

export class HintButton extends GameActionButton {
    keyEventsActive = false;

    constructor(index: number) {
        super('hint', index);
        GameEvent.add(EventName.GAME_INTRO_COMPLETED, () => this.onReady());
        GameEvent.add(EventName.ADS_GRANTED, this.updateCounter);
        GameEvent.add(EventName.HINT_SHOW, this.updateCounter);
        GameEvent.add(EventName.SET_HINT_DISABLED, this.setDisabled);
        GameEvent.add(EventName.BLOCK_KEYBOARD, () => {
            this.keyEventsActive = false;
        });
        GameEvent.add(EventName.UNBLOCK_KEYBOARD, () => {
            this.keyEventsActive = true;
        });

        addEventListener('keydown', this.onKeyDown.bind(this));
    }

    onKeyDown(e: KeyboardEvent) {
        if (!this.keyEventsActive) return;
        if (e.code === 'KeyH') {
            this.action();
        }
    }
    onReady() {
        this.setDisabled(false);
        this.blockMove = 0;
        this.updateCounter();
    }

    onClick() {
        if (Store.hintCounter < 1) {
            this.blockButton(Infinity);
            GameEvent.emit(EventName.SHOW_ADS, { place: 'hint' });
            return;
        }
        GameEvent.emit(EventName.HINT);
    }

    getStoreCounter() {
        return Store.hintCounter;
    }
}
